import axios from 'axios'
import router from '@/router/index.js'
import store from '../store/index.js'
import {mymessagetip} from '../js/resetMessage.js'
import Bus from '@/js/bus'
import {
  BASE_URL
} from '../../config/env'
let obvTestHost = 'https://cloud.dev.pkpm.cn'
// 开发

export const baseUrl = BASE_URL.BASE_API
export const testHost2 = BASE_URL.TEST_HOST_API
// 登录代理 登录接口代理 wxloginapi gettokenapi getEnterpriseAdminTokenApi logoutApi
export const testLogin = BASE_URL.TEST_LOGIN_API

export const trialUrl = BASE_URL.TRAIL_API
/* 注意如要修改testHost2，请将如下TESTHOSTTWO同步修改 */
export const TESTHOSTTWO = BASE_URL.TEST_HOST_API
// 付款baseurl
export const wxpaybaseurl = BASE_URL.BASE_API

//试用中心产品详情接口
export const GetTrialCenterProductInfoApi = (params) => {
  return axios({
    method: 'get',
    url: testHost2 + `/api/Products/GetTrialCenterProductInfo/trialCenterProductId/${params.trialCenterProductId}`
  })
}

//试用中心产品详情接口--对接产品中心V2版本
export const GetTrialCenterProductInfoV2Api = (params) => {
  return axios({
    method: 'get',
    url: testHost2 + `/api/Products/GetTrialCenterProductInfoV2/trialCenterProductId/${params.trialCenterProductId}`,
    params
  })
}

//对接产品中心-根据产品中心的id获取产品详情V2
export const AbutmentproductCenterIdV2Api = (params) => {
  return axios({
    method: 'get',
    url: testHost2 + `/api/Products/GetTrialCenterProductInfoV2/productCenterId/${params.productCenterId}`,
    params
  })
}


//获取试用中心产品列表
export const getTrialCenterProductListApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + '/api/Products/TrialCenterProductList'
  })
}

// 开建申请
export const authentication = {
  credentials: {
    client_id: 'acme',
    client_secret: 'acmesecret',
    grant_type: 'client_credentials'
  },
  baseUrl: obvTestHost
}

export const getReginApi = (params) => {
  return axios({
    method: 'post',
    headers: {
      'Authorization': 'WEB_ANONYMOUS'
    },

    url: baseUrl + '/pkpm/city/list?parentId=' + params.parentId + '&type=' + params.type + '&r=' + Math.random()
  })
}

export const getCodeApi = (params) => {
  return axios({
    method: 'post',
    headers: {
      'Authorization': 'eyJhbGciOiJIUzUxMiJ9.eyJBQ0NPVU5UIjoib2ZmaWNpYWx3ZWJzaXRlIiwiUk9MRUlORk8iOlt7ImF1dGhvcml0eSI6IjEifV0sIlVTRVJJRCI6IjE2IiwiVkVSU0lPTiI6IjAifQ.bOKMfcTHtsXqcJCpNNpu6DeVP2AJvnR57tWlgm4yxjVfg_DaE3gWwg8S2AXiKUR46eC9V8PUkcf6hWmk--e5eQ'

    },
    url: baseUrl + '/pkpm/userInfo/sendCodeSms?phone=' + params.phone + ''
  })
}
export const postCodeApi = (params) => {
  return axios({
    method: 'post',
    headers: {
      'Authorization': 'eyJhbGciOiJIUzUxMiJ9.eyJBQ0NPVU5UIjoib2ZmaWNpYWx3ZWJzaXRlIiwiUk9MRUlORk8iOlt7ImF1dGhvcml0eSI6IjEifV0sIlVTRVJJRCI6IjE2IiwiVkVSU0lPTiI6IjAifQ.bOKMfcTHtsXqcJCpNNpu6DeVP2AJvnR57tWlgm4yxjVfg_DaE3gWwg8S2AXiKUR46eC9V8PUkcf6hWmk--e5eQ'
    },
    data: params,
    url: baseUrl + '/pkpm/userInfo/verifySendCode'
  })
}
export const searchCompanyListApi = (params) => {
  return axios({
    method: 'get',
    headers: {
      'Authorization': 'WEB_ANONYMOUS'
    },
    params: params,
    url: baseUrl + '/pkpm/tianyancha/executeGet'
  })
}

//天眼查 --根据统一社会信用代码查询企业名称
export const TYCSocietyCodeApi = (params) => {
  return axios({
    method: 'get',
    headers: {
      'Authorization': 'WEB_ANONYMOUS'
    },
    params: params,
    url: baseUrl + '/pkpm/tianyancha/queryBaseInfo'
  })
}

/// api/v1/Authcode/enterpriseUserByPhoneNumberF
// 根据企业手机号获取userid
export const getenterpriseUserApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost + '/api/v1/Authcode/enterpriseUserByPhoneNumber'
  })
}
// 根据教育机构手机号获取userid
/// api/v1/Authcode/educationUserByPhoneNumber
export const geteducationUserApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost + '/api/v1/Authcode/educationUserByPhoneNumber'
  })
}
// 添加企业用户信息 /api/v1/Authcode/enterpriseUsers
export const postenterpriseUserApi = (params) => {
  return axios({
    method: 'post',
    data: params,
    url: testHost + '/api/v1/Authcode/enterpriseUsers'
  })
}
// 添加学校用户信息 /api/v1/Authcode/educationUsers
export const posteducationUsersApi = (params) => {
  return axios({
    method: 'post',
    data: params,
    url: testHost + '/api/v1/Authcode/educationUsers'
  })
}
// 申请试用码 /api/v1/Authcode/assignAuthcodes
export const requestassignAuthcodeApi = (params) => {
  return axios({
    method: 'post',
    params: params,
    url: testHost2 + '/api/v1/Authcode/assignAuthcodes'
  })
}

//上次头像
export const AddOrUpdateUserHeadImageApi = (data) => {
  return axios({
    method: 'put',
    data: data,
    url: testHost2 + '/api/v1/User/AddOrUpdateUserHeadImage'
  })
}

//获取用户上传的头像
export const GetUserHeadImageApi = (data) => {
  return axios({
    method: 'get',
    url: testHost2 + '/api/v1/User/GetUserHeadImage'
  })
}

// 申请试用码
export const assignAuthcodesApi = (params) => {
  return axios({
    method: 'post',
    params:params,
    url: testHost2 + '/api/v1/User/assignAuthcodes'
  })
}

// 申请试用授权 /api/Bit/assignBitAccount
export const requestassignBitApi = (params) => {
  return axios({
    method: 'get',//现在改成get，之前post /api/Bit/assignBitAccount
    params: params,
    //url: testHost2 + '/api/Bit/assignBitAccount',之前是这个
    url: testHost2 + '/api/v1/User/assignBitAccount'
  })
}
export const getunusedAuthcodeCountApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + '/api/v1/Authcode/unusedAuthcodeCount'
  })
}
export const getassignedAuthcodeCountApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + '/api/v1/Authcode/assignedAuthcodeCount'
  })
}
export const postIphoeAuthCodeApi = (params) => {
  return axios({
    method: 'post',
    headers: {
      'Authorization': 'WEB_ANONYMOUS'
    },
    data: params,
    url: baseUrl + '/pkpm/userInfo/ProductLicenseKey'
  })
}
// 以下为新试用中心对接云平台入口接口
// 验证用户是否存在 （用户ID 、邮箱、手机号）
export const getUserExistApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + '/api/v1/User/checkExist',
    timeout:15000
  })
}
//  /users/checkExist

// 获取手机验证码
export const getMobileCodeApi = (params) => {
  return axios({
    method: 'post',
    data: params,
    url: testHost2 + '/api/v1/User/verifyMobile'
  })
}
// 获取邮箱验证码
export const getEmailCodeApi = (params) => {
  return axios({
    method: 'post',
    data: params,
    url: testHost2 + '/api/v1/User/verifyMail'
  })
}
// 添加用户  (云平台注册添加用户)
export const addUserApi = (params) => {
  return axios({
    method: 'post',
    data: params,
    url: testHost2 + '/api/v1/User/regist'
  })
}
// 个人用户注册
export const addPersonUserApi = (params) => {
  return axios({
    method: 'post',
    data: params,
    url: testHost2 + '/api/v1/User/PersonalUserRegist'
  })
}
// 企业用户注册  enterprise
export const addEnterpriseUserApi = (params) => {
  return axios({
    method: 'post',
    data: params,
    url: testHost2 + '/api/v1/User/EnterpriseUserRegist'
  })
}
// 添加用户  (试用中心添加用户)
export const addTrialCenterUserApi = (params) => {
  return axios({
    method: 'post',
    data: params,
    url: testHost2 + '/api/v1/User/users'
  })
}
// 获取登录token
export const getTokenApi = (params) => {
  return axios({
    headers:{'appId': params.appId ? params.appId : 'Unified_Access_Service'},
    method: 'post',
    params: params,
    // url: testHost2 + '/api/v1/User/login',
    url: testLogin + '/api/v1/User/login',
    timeout:15000
    // url: obvTestHost+'/bimserver/auth/oauth/token',

  })
}
// 刷新登录RefreshToken
export const getRefreshTokenApi = (params) => {
  return axios({
    // headers:{'Content-Type':'x-www-form-urlencoded'},
    method: 'post',
    data: params,
    url: testHost2 + '/api/v1/User/refresh'
    // url: obvTestHost+'/bimserver/auth/oauth/token',

  })
}
// 企业管理员登录
export const getEnterpriseAdminTokenApi = (params,params2) => {
  return axios({
    headers: {'appId': params.appId ? params.appId : 'Unified_Access_Service'},
    method: 'post',
    data: params,
    params:params2,
    // url: testHost2 + '/api/Enterprise/EnterpriseAdminLogin',
    url: testLogin + '/api/Enterprise/EnterpriseAdminLogin',
    timeout:15000
  })
}
// 获取登录token
export const postPhoneCodeApi = (params) => {
  return axios({
    // headers:{'Content-Type':'x-www-form-urlencoded'},
    method: 'get',
    url: testHost2 + '/api/v1/User/MobildCodeLogin/mobile/' + params.mobile + '/code/' + params.code
    // url: obvTestHost+'/bimserver/auth/oauth/token',

  })
}
// 获取微信扫码登录token
export const getWXTokenApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + '/api/WeChat/GetWechatAccessToken'
    // url: obvTestHost+'/bimserver/auth/oauth/token',

  })
}
// 获取微信扫码用户信息
export const getWXUserInfoApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + '/api/WeChat/GetWechatUserInfo'

  })
}
// 微信扫码登录
export const WXLoginApi = (params) => {
  return axios({
    headers: {'appId': params.appId ? params.appId : 'Unified_Access_Service'},
    method: 'post',
    params: params,
    // url: testHost2 + '/api/v1/User/WeChatLogin'
    url: testLogin + '/api/v1/User/WeChatLogin'

  })
}
// 绑定微信用户
export const WXBindUserApi = (params) => {
  return axios({
    method: 'post',
    data: params,
    url: testHost2 + '/api/v1/User/WeChatBind'

  })
}
// 退出登录
export const  logoutApi = async(params) => {
  return await axios({
    // headers:{'Content-Type':'x-www-form-urlencoded'},
    method: 'post',
    params: params,
    url: testLogin + '/api/v1/User/logout'
    // url: testHost2 + '/api/v1/User/logout'
    // url: obvTestHost+'/bimserver/auth/oauth/token',

  })
}
// sso退出登录
export const  SsoLogout = async(params) => {
  return axios({
    method: 'get',
    params: params,
    url: testLogin + '/api/v1/User/SsoLogout'
  })
}
// 根据原密码修改密码
export const revisePasswordApi = (params, data) => {
  return axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    params: params,
    data: data,
    url: testHost2 + '/api/v1/User/changePassword'
  })
}
// 获取用户授权码列表
export const getUserAuthCodesApi = (params) => {
  return axios({
    method: 'get',
    // params:params,
    url: testHost2 + '/api/v1/PersonalCenter/myAuthcodes'
  })
}
// 获取用户信息
export const getUserInfoApi = (params) => {
  return axios({
    method: 'get',
    // params:params,
    url: testHost2 + '/api/v1/PersonalCenter/userInformation'
  })
}

//获取用户信息，新增接口关联用户部门及企业信息 2022-0704
export const GetUserAndEnterprisesApi = (params) => {
  return axios({
    method: 'get',
    // params:params,
    url: testHost2 + '/api/v1/PersonalCenter/GetUserAndEnterprises'
  })
}





// 获取用户id
export const getUserIdApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + '/api/v1/User/userByPhoneNumber'
  })
}
// 判断信息是否全面
export const checkUserInfoApi = (data) => {
  return axios({
    method: 'get',
    params: data,
    url: testHost2 + '/api/v1/User/checkUserInformation'
  })
}
// 通过用户ID更新用户信息
export const updateUserInfoApi = (data) => {
  return axios({
    method: 'post',
    data: data,
    url: testHost2 + '/api/v1/User/modifyUserwithId'
  })
}

// 通过用户Id修改用户及关联企业信息
export const ModifyUserAndEnterpriseWithIdApi = (data) => {
  return axios({
    method: 'post',
    data: data,
    url: testHost2 + '/api/v1/User/ModifyUserAndEnterpriseWithId'
  })
}


// 获取申请配置
export const getRequestConfig = (data) => {
  return axios({
    method: 'get',
    //url: testHost2 + '/api/v1/Authcode/AuthcodeConfig'
    url: testHost2 + '/api/v1/User/GetCurrentUserAuthcodeConfig'
  })
}
// 验证token状态
export const getTokenStatus = (data) => {
  return axios({
    method: 'get',
    url: testHost2 + '/api/v1/User/userStatus'
  })
}
// 获取组织（默认返回我参与的组织）
export const getCloudDiskInfoApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: cloudDiskUrl + '/bimserver/tmds/v3/accounts'
  })
}
// 获取产品名称列表
export const getProductListApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + '/api/Bit/ManageTrialSNList'
  })
}
//获取图片验证码
export const GetImageCaptchaApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + `/api/v1/User/GetImageCaptcha/width/${params.width}/height/${params.height}/len/${params.len}`
  })
}
//获取登录失败次数
export const GetLoginFailedCountApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 + `/api/v1/User/GetLoginFailedCount/userName/${params.userName}`
  })
}
//获取到登录公钥
export const GetTransecpubkeyApi = (params) => {
  return axios({
    method: 'get',
    params: params,
    url: testHost2 +`/api/v1/User/GetPassportPubKey`
  })
}

//创建试用申请审核数据，包括直接发放和审批通过后发放，会议试用和试用申请同时用这个接口
export const ApplyTrialAndMeetingOrAuditByNeocrmApi = (data) => {
  return axios({
    method: 'post',
    data: data,
    url: testHost2 +`/api/v1/User/ApplyTrialAndMeetingOrAuditByNeocrm`
  })
}

//撤销试用申请
export const RepealTrialAndMeetingAuditApi = (data) => {
  return axios({
    method: 'post',
    params: data,
    url: testHost2 +`/api/v1/User/RepealTrialAndMeetingAudit`
  })
}



export const routerreplace=(params)=>{
  router.replace(params);
  localStorage.clear();
}

export const currentRoutecheck=()=>{
  if(router.currentRoute.path=='/meetingProIntroduce'){
    routerreplace({name:'login',query:{fromroute:router.currentRoute.fullPath}})
  }else if(router.currentRoute.query.fromroute){
    routerreplace({name:'login',query:{fromroute:router.currentRoute.query.fromroute}})
  }else if(router.currentRoute.query.direct){//产品中心带token登录，direct去其他页面
    routerreplace({name:'login',query:{direct:router.currentRoute.query.direct}})
  }else{
    console.log(router.currentRoute)
    routerreplace({name:'login'})
  }
}

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // console.log(config)
    if (config.url.includes('pkpmuser-api') || config.url.includes('demo')) {
      let token = localStorage.getItem('token')
      if (localStorage.getItem('token')) {
        config.headers.Authorization = token
      }
      //全局请求头加企业id 有些权限接口
      let enterPriseName=store.state.enterPriseName
      if(enterPriseName && enterPriseName!=='个人'){
        config.headers.EnterpriseId = enterPriseName
      }else{
        config.headers.EnterpriseId = ''
      }
      
    }
    config.headers.Ac
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
let istip = true
// axios.defaults.withCredentials = true
// http response 拦截器
axios.interceptors.response.use(
  response => {

    return response
  },
  async error => {
    if (error.response.status === 404) {
      if (error.response.request.responseURL.indexOf('?ReturnUrl') > -1) {
        if (istip) {
          mymessagetip.error({
            message: '该账号已在其他终端登录，当前账号被退出，请重新登录', duration: 3 * 1000
          })
          istip = false
          setTimeout(() => {
            istip = true
          }, 300000)
        }
        currentRoutecheck()
        return
      }
    }
    if(error.message=='Network Error'){
      mymessagetip.error({
        message:'Network Error！',duration: 3 * 1000
      })
      return Promise.reject('Network Error！')
    }else if(error.message.includes("timeout")){
      mymessagetip.error({
        message:'系统繁忙，请稍后再试！',duration: 3 * 1000
      })
      return Promise.reject('系统繁忙，请稍后再试！')
    }
    if(error.response.config.url.includes("User/refresh")){
      debugger
      currentRoutecheck()
      return
    }
    console.log(error.response, '--------error')
    let token = localStorage.getItem('token')
    let refreshToken = localStorage.getItem('refreshToken')

    let passportToken=localStorage.getItem('passportToken')
    let passportRefreshToken=localStorage.getItem('passportRefreshToken')
    if (error.response) {
      // 1. 如果没有refresh_token,则直接跳转登录页
      if (error.response.status == 401 && !refreshToken) {
        debugger
        console.log(router.currentRoute)
        console.log(router.currentRoute.path,'-------')
        currentRoutecheck()
        return
      }
      if (error.response.status == 401 && refreshToken) {
        debugger
        // 2.如果有refresh_token，则请求更新token
          let params = {}
          params.accessToken = token.split('Bearer ')[1]
          params.refreshToken = refreshToken
          params.isWebClient = true
          params.passportToken=passportToken.split('Bearer ')[1]
          params.passportRefreshToken=passportRefreshToken.split('Bearer ')[1]
          try {
            const { data } = await axios({
              method: 'post',
              data: params,
              url: testHost2 + '/api/v1/User/refresh'
            })

            // 3.如果刷新token成功了，则把新的token更新到容器中
            if (data.data && data.data.accessToken) {
              localStorage.setItem('token', 'Bearer ' + data.data.accessToken)
              localStorage.setItem('refreshToken',data.data.refreshToken)
              localStorage.setItem('passportRefreshToken','Bearer ' +data.data.passportRefreshToken)
              localStorage.setItem('passportToken','Bearer ' +data.data.passportToken)
              //刷新token后,消息推送机制的token需要同步刷新到最新，否则不能向指定用户再推送消息
              Bus.$emit('signalRupdate','updatetoken')
              // 4.把之前失败的请求继续发出去
              return axios(error.config)
            } else {
              currentRoutecheck()
              return
            }
          } catch (error) {
            debugger
            console.log('刷新token失败', error)
            mymessagetip.error({
              message:'登录到期！',
              duration: 3 * 1000
            })
            currentRoutecheck()
            return
          }
      }
      if(error.response.status == 403){//返回403,用户登录账号互踢情况
        
        console.log(error.response)
        if(error.response.data){
            console.log(error.response.data)
            // mymessagetip.error({
            //   message:error.response.data,
            //   duration: 3 * 1000
            // })
            //不需要写了，组件内接口调用处已经catch住了
        }else{
          mymessagetip.error({
            message:'该账号已在其他终端登录，当前账号被退出，请重新登录。',
            duration: 5 * 1000
          })
          store.commit('setCurrentVerifystatus', '')
          logoutApi()
          .then(res=>{
            debugger
            currentRoutecheck()
            return
            })
          .catch(err=>{
            currentRoutecheck()
            return
            })
        }
      }
    }
    return Promise.reject(error.response) // 返回接口返回的错误信息
  }
)



// WEBPACK FOOTER //
// ./src/js/api.js